// extracted by mini-css-extract-plugin
export default {"failure":"NbIPIHD2Nf3J4cmuzDzB"};